export enum MapType {
  Hybrid = "hybrid",
  Terrain = "terrain",
}
